import { z } from "zod";

/**
 * Vor-Ort-Ausnahme je Account (Kunde × Segment), Spec 2026-09-29 (#248).
 *
 * Gründe liegen beim Kunden oder in der Lage, nie in unserer Einschätzung:
 * „Service-Umfang zu klein" fehlt bewusst — die wirtschaftliche Bedeutung
 * beantwortet die BCG-Einordnung, die die Frequenz setzt.
 */
export const EXEMPTION_REASONS = [
  "customer_declines",
  "no_contact",
  "relationship_ending",
  "other",
] as const;
export const exemptionReasonSchema = z.enum(EXEMPTION_REASONS);
export type ExemptionReason = z.infer<typeof exemptionReasonSchema>;

export const EXEMPTION_STATUSES = [
  "requested",
  "approved",
  "rejected",
  "withdrawn",
  "revoked",
  "expired",
] as const;
export type ExemptionStatus = (typeof EXEMPTION_STATUSES)[number];

export const createExemptionSchema = z.object({
  customerId: z.string().uuid(),
  segmentId: z.string().uuid(),
  reason: exemptionReasonSchema,
  // Die Untergrenze verhindert „." oder „siehe oben" (10 Zeichen) als Begründung.
  note: z.string().trim().min(15),
});
export type CreateExemptionInput = z.infer<typeof createExemptionSchema>;

export const decideExemptionSchema = z.object({
  note: z.string().trim().min(1).optional(),
});
export type DecideExemptionInput = z.infer<typeof decideExemptionSchema>;

export const visitExemptionSchema = z.object({
  id: z.string().uuid(),
  customerId: z.string().uuid(),
  customerName: z.string(),
  segmentId: z.string().uuid(),
  segmentName: z.string(),
  reason: exemptionReasonSchema,
  note: z.string(),
  status: z.enum(EXEMPTION_STATUSES),
  requestedBy: z.object({ id: z.string().uuid(), fullName: z.string() }),
  requestedAt: z.string(),
  decidedBy: z.object({ id: z.string().uuid(), fullName: z.string() }).nullable(),
  decidedAt: z.string().nullable(),
  decisionNote: z.string().nullable(),
  validUntil: z.string().nullable(),
});
export type VisitExemption = z.infer<typeof visitExemptionSchema>;
